import { IAppState } from '../../../AppModulesWrapper';

export function selectJKHouseId(state: IAppState): number | undefined {
  return state.servicePickerWidget.offer.geo?.jk?.house?.id;
}
